<template>
  <div>
<!--    <link rel="stylesheet" media="all" type="text/css" href="/static/front/summernote.css">-->
<!--    <link rel="stylesheet" media="all" type="text/css" href="/static/front/style.css">-->
<!--    <link rel="stylesheet" media="all" type="text/css" href="/static/front/custom.css">-->
<!--    <link rel="stylesheet" media="all" type="text/css" href="/static/front/loading-bar.min.css">-->
<!--    <link rel="stylesheet" media="all" type="text/css" href="/static/front/minimal-menu.css">-->
    <HeaderPublic></HeaderPublic>
    <router-view name="public"></router-view>
  </div>
</template>

<script>
import Vue from 'vue'
import HeaderPublic from '../components/public/Header.vue'
import VueHead from 'vue-head'
Vue.use(VueHead)
export default {
  // head: {
  //   link: [
  //     {rel: 'stylesheet', href: '/static/front/bootstrap/dist/css/bootstrap.min.css'}
  //   ]
  // },
  components: {HeaderPublic}
}
</script>



// WEBPACK FOOTER //
// src/components/PublicPanel.vue